module.exports = __webpack_public_path__ + "basic-top-bw.svg?fea5d9320d37b66d5fcb34143e517ae8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/basic-top-bw.svg
// module id = 71
// module chunks = 0